<div class="config-column">
    <button (click)="onHide$.emit()" class="config-column__hide">
        <i class="pi pi-times"></i>
    </button>
    
    <div class="config-column__header">
        <span class="config-column__header__title">
            {{'listConfig'|translate}}
        </span>
        <button (click)="restoreDefaultConfig()" class="config-column__header__restore">
            <i class="pi pi-replay"></i>
            <span>{{'restoreDefaultListConfig'|translate}}</span>
        </button>
    </div>
    <span class="config-column__info">
        {{'instructionsConfigList'|translate}}
    </span>

    <div #list class="config-column__list">
        <button
            *ngFor="let item of columnsSort"
            [ngClass]="{
                'is-hidden': !item.isVisible,
                'no-drag': item.id === COLUMN_ID.name
            }"
            [attr.data-id]="item.id"
            class="column"
        >
            <i class="pi pi-ellipsis-h icon-drag"></i>

            <div class="column__content">
                <span class="column__content__title">
                    {{item.title}}
                </span>

                <div class="column__content__value-wrapper">
                    <ng-container *ngIf="item.description">
                        <span class="column__content__value">
                            {{item.description}}
                        </span>
                    </ng-container>
    
                    <ng-container *ngIf="COLUMN_ID.status === item.id">
                        <img src="/assets/images/vehicles/i-driving.svg" alt="">
                    </ng-container>
    
                    <ng-container *ngIf="COLUMN_ID.etoll === item.id || COLUMN_ID.sent === item.id">
                        <img src="/assets/images/layout/etoll-sending.svg" alt="">
                    </ng-container>

                    <ng-container *ngIf="COLUMN_ID.gps === item.id || COLUMN_ID.gsm === item.id">
                        <p-progressBar [showValue]="false" [value]="item.isVisible ? 75 : 0"></p-progressBar>
                    </ng-container>

                    <ng-container *ngIf="COLUMN_ID.lock === item.id">
                        <i class="pi pi-lock lock-icon"></i>
                    </ng-container>

                    <ng-container *ngIf="COLUMN_ID.sensor === item.id">
                        <div class="sensors">
                            <div class="sensors__item">
                                <span>BZ</span>
                            </div>
                            <div [ngClass]="{'active': item.isVisible}" class="sensors__item">
                                <span>KL</span>
                            </div>
                            <div class="sensors__item">
                                <span>KP</span>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>

            <p-inputSwitch [(ngModel)]="item.isVisible" [disabled]="item.id === COLUMN_ID.name"></p-inputSwitch>
        </button>
    </div>

    <p-button 
        (click)="save()"
        class="save"
        [label]="'primeng.apply' | translate"
    ></p-button>
</div>
